import { Component, Story, Knobs, Accents } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  value: {
    default: '5',
    editor: 'textbox',
    delimiter: '\n      ',
  },
  size: {
    default: 'small',
    editor: 'dropdown',
    editorOptions: ['small', 'large'],
    delimiter: '\n      ',
  },
  accent: { default: 'tango', editor: 'dropdown', editorOptions: Accents, delimiter: '\n      ' },
};

const PlaygroundKnobs_v3: Knobs = {
  value: {
    default: '5',
    editor: 'textbox',
    delimiter: '\n      ',
  },
  size: {
    default: 'small',
    editor: 'dropdown',
    editorOptions: ['small', 'large'],
    delimiter: '\n      ',
  },
  accent: { default: 'tango', editor: 'dropdown', editorOptions: Accents, delimiter: '\n      ' },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'An badge on a div where you can change all the attributes',
  coreComponent: {
    html: `<div style='position:relative; height:100px; width:100px; background-color:#e8e8e8; border-radius: 3px;'>
  <div style='position:absolute; top:-10px; right:-10px;'>
    <tag-badge {{...knobs}}>
    </tag-badge>
  </div>
</div>`,
    knobs: PlaygroundKnobs,
  },
  coreComponent_v3: {
    html: `
    <div style='position:relative; height:100px; width:100px; background-color:#e8e8e8; border-radius: 3px;'>
      <div style='position:absolute; top:-10px; right:-10px;'>
        <tag3-badge {{...knobs}}></tag3-badge>
      </div>
    </div>
    `,
    knobs: PlaygroundKnobs_v3,
  },
  reactWrapper: {
    jsx: `<div style={{position: "relative", height: "100px", width: "100px", backgroundColor: "#e8e8e8", "borderRadius": "3px"}}>
  <div style={{position: "absolute", top: "-10px", right: "-10px"}}>
    <TagBadge {{...knobs}} />
  </div>
</div>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Example {{accent}} {{value}} {{size}}/>`,
    parentJSX: `const Example = ({value, accent, size}) => {
      return (
        <div style={{position: "relative", height: "100px", width: "100px", backgroundColor: "#e8e8e8", "borderRadius": "3px"}}>
          <div style={{position: "absolute", top: "-10px", right: "-10px"}}>
            <Tag3Badge size={size} accent={accent}>{value}</Tag3Badge>
          </div>
        </div>
      );
    }`,
    knobs: PlaygroundKnobs_v3,
  },
};

export const TagBadgeDocs: Component = {
  type: 'component',
  name: 'badge',
  description: 'Renders a "badge" that can be placed on other elements',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'value',
      description: 'The value to go in the badge',
      type: 'string',
    },
    {
      name: 'accent',
      description: 'The colour of the badge',
      type: 'string',
      default: 'dolphinblue',
    },
    {
      name: 'size',
      description: 'The size of the badge. large | small ',
      type: 'string',
      default: 'large',
    },
    {
      name: 'colourScheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [PlaygroundStory],
};
